import i18n from "../language/i18n";

export interface INavigationOption {
  id: string;
  name: string;
  visible: boolean;
  icon: string;
  selectedIcon: string;
  roleList: string[];
  authorityScreenName: string;
  navigate: string;
  subOptionList: INavigationOption[] | null;
}

// There is ONE ödev entry: destek ödevleri live inside Ödevler (they are rows in the same
// list, badge and dashboard card), so a second "Çalışmalar" tab would point at a list
// that no longer exists — /support-assignments now redirects to /homeworks.
//
// `icon`/`selectedIcon` are canonical Icon names rendered via <Icon> (the colored
// gamification ones — contest, market, practise-now, profile — map to Phosphor
// Fill glyphs). MainLeftNavigation still guards with iconExists() and falls back
// to a raw <img> for any value the icon system doesn't recognize.
export const retrieveLearnerMainLeftNavigationOptionList =
  (): INavigationOption[] => {
    return [
      {
        id: "homeworks",
        name: i18n.t("homeworks"),
        visible: true,
        icon: "homework",
        selectedIcon: "homework-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/homeworks",
        subOptionList: null,
      },
      {
        id: "learning-path",
        name: i18n.t("learning_path"),
        visible: true,
        icon: "learning-path",
        selectedIcon: "learning-path-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/learning-path",
        subOptionList: null,
      },
      {
        id: "reports",
        name: i18n.t("reports"),
        visible: true,
        icon: "report",
        selectedIcon: "report-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/reports",
        subOptionList: null,
      },
      {
        id: "contests",
        name: i18n.t("contest"),
        visible: true,
        icon: "contest",
        selectedIcon: "contest-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/contests",
        subOptionList: null,
      },
      {
        id: "market",
        name: i18n.t("market"),
        visible: true,
        icon: "market",
        selectedIcon: "market-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/market",
        subOptionList: null,
      },
      {
        id: "plans",
        name: i18n.t("plans"),
        visible: true,
        icon: "framework-annual-plan",
        selectedIcon: "framework-annual-plan-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/framework-annual-plans",
        subOptionList: null,
      },
      {
        id: "practises",
        name: i18n.t("practise_now"),
        visible: true,
        icon: "practise-now",
        selectedIcon: "practise-now-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/practise",
        subOptionList: null,
      },
      // Photo solving has its own page (it used to be the third Pratik yap tab), so it
      // sits right after Pratik yap.
      {
        id: "photo-solve",
        name: i18n.t("photo_solve"),
        visible: true,
        icon: "photo-solve",
        selectedIcon: "photo-solve-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/photo-solve",
        subOptionList: null,
      },
      {
        id: "announcements",
        name: i18n.t("announcements"),
        visible: true,
        icon: "announcement",
        selectedIcon: "announcement-selected",
        roleList: ["LEARNER"],
        authorityScreenName: "dashboard",
        navigate: "/announcements",
        subOptionList: null,
      },
    ];
  };

